// extracted by mini-css-extract-plugin
module.exports = {"native-call-footer":"native-book-a-call_native-call-footer__zsY6s","native-call-container":"native-book-a-call_native-call-container__-RqnC"};